module.exports = __webpack_public_path__ + "img/login-background-3.e313c04f.jpg";